<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> IMPORTAÇÃO DE PRODUTOS </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title>XML</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- <v-toolbar-title
          >Fornecedor: 0248 - PG4 IND CALÇADOS E ARTEF DE COURO
          LTDA</v-toolbar-title
        > -->
        <v-spacer></v-spacer>
        <!-- <v-btn dark color="blue darken-3" @click="showImageGalery()">
          <v-icon left>mdi-image-album</v-icon> Galeria Fotos
        </v-btn> -->
        <v-btn
          v-if="page == 'home'"
          color="blue darken-3"
          class="white--text"
          :disabled="!xml.gerador.empresa_existe"
          @click="nextPage('products')"
        >
          Avançar
          <v-icon right>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          v-if="page == 'products'"
          outlined
          color="grey darken-3"
          @click="page = 'home'"
        >
          <v-icon left>mdi-chevron-left</v-icon>
          Voltar
        </v-btn>
        <progress-bar :loading="loading" :inderterminate="loading" />
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid v-if="statusAlert">
          <v-row>
            <v-col>
              <alert
                :visible="statusAlert"
                :type="typeAlert"
                :message="messageAlert"
                :clickClose="() => (statusAlert = false)"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid v-if="page == 'home'">
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :loading="loadingCompany"
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.description}`"
                item-value="id"
                v-model="company"
                label="Fornecedor"
                required
                dense
                outlined
                :rules="[requiredProductExist]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <template>
                <v-file-input
                  prepend-icon="mdi-file-code-outline"
                  @change="onFilePicked"
                  label="XML"
                  outlined
                  dense
                ></v-file-input>
              </template>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-btn color="blue darken-3" dark class="" @click="validate()">
                <v-icon left>mdi-cloud-upload-outline</v-icon> IMPORTAR
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn color="green darken-3" dark class="" v-if="false">
                <v-icon left>mdi-check</v-icon> Confirmar Importação
              </v-btn>
              <!-- <v-divider></v-divider> -->
              <alert
                :visible="!!error"
                :type="error"
                color="pink darken-1"
                :message="error"
                :clickClose="() => (error = '')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table dense fixed-header class="border-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        :colspan="3"
                        class="blue--text title font-weight-bold"
                      >
                        VALIDAÇÃO DO XML
                      </th>
                    </tr>
                    <tr>
                      <th class="text-right" width="70">#</th>
                      <th>Descrição</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody v-if="xml.gerador">
                    <tr class="font-weight-bold">
                      <td class="text-right">1</td>
                      <td>
                        Arquivo gerado por {{ xml.gerador.razao }} CNPJ:
                        {{ xml.gerador.cnpj }}
                      </td>
                      <td>
                        <label
                          v-if="xml.gerador.empresa_existe"
                          class="green--text"
                          >Fornecedor: {{ xml.gerador.empresa.code }} -
                          {{ xml.gerador.empresa.name }}</label
                        >
                        <label v-else class="red--text"
                          >CNPJ Não cadastrado no sistema</label
                        >
                      </td>
                    </tr>
                    <tr class="font-weight-bold">
                      <td class="text-right">2</td>
                      <td>
                        Total de produtos encontrados:
                        {{ xml.produtos.produto.length }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table
                dense
                fixed-header
                height="300"
                class="border-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        :colspan="5"
                        class="blue--text title font-weight-bold"
                      >
                        Produtos
                      </th>
                    </tr>
                    <tr>
                      <th class="text-right" width="70">#</th>
                      <th>Produto</th>
                      <th width="200">Status Produto</th>
                      <th width="">Material</th>
                      <th width="">Cor</th>
                      <!-- <th width=""></th> -->
                    </tr>
                  </thead>
                  <tbody v-if="xml.gerador">
                    <tr
                      v-for="(product, index) in xml.produtos.produto"
                      :key="product.pcod"
                    >
                      <td class="text-right">{{ ++index }}</td>
                      <td>{{ product.pcod }} - {{ product.pcategoria }}</td>
                      <td class="font-weight-bold">
                        <label v-if="product.produto_existe" class="blue--text"
                          >Atualização de Produto</label
                        >
                        <label v-else class="green--text"
                          >Cadastro de Produto</label
                        >
                      </td>
                      <td>
                        <div
                          class="font-weight-bold"
                          v-for="material in getMaterials(product)"
                          :key="`${product.pcod}-${material.material_code}-${material.cor_code}`"
                        >
                          <label v-if="material.material"
                            >{{ material.material_code }} -
                            {{ material.material.name }}</label
                          >
                          <label v-else class="red--text"
                            >Material não cadastrado:
                            {{ material.material_code }}</label
                          >
                          <br />
                        </div>
                      </td>
                      <td>
                        <div
                          class="font-weight-bold"
                          v-for="material in getMaterials(product)"
                          :key="`${product.pcod}-${material.material_code}-${material.cor_code}`"
                        >
                          <label v-if="material.cor"
                            >{{ material.cor_code }} -
                            {{ material.cor.name }}</label
                          >
                          <label v-else class="red--text"
                            >Cor não cadastrada: {{ material.cor_code }}</label
                          >
                          <br />
                        </div>
                      </td>
                      <!-- <td v-if="index == 7">Produto Encontrado no Sistema</td>
                      <td v-else>Produto Novo</td> -->
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid v-if="page == 'products'">
          <v-row>
            <v-col cols="12" class="mb-3">
              <span class="font-weight-normal text-h5">
                Produto <b>{{ indexProduct + 1 }}</b> de
                <b>{{ produtos.length }}</b>
              </span>
            </v-col>
          </v-row>
          <v-card elevation="2">
            <v-card-title class="text-h6">
              Dados Gerais
              <v-chip
                class="ma-2"
                color="blue"
                label
                text-color="white"
                v-if="productSelected.produto_existe"
              >
                <v-icon left>mdi-label</v-icon> Atualização de Produto
              </v-chip>
              <v-chip
                class="ma-2"
                color="green"
                label
                text-color="white"
                v-else
              >
                <v-icon left>mdi-label</v-icon> Cadastro de Produto
              </v-chip>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="productSelected.pcod"
                    class="text-field-uppercase"
                    label="Código do Produto"
                    dense
                    :disabled="disabledFieldsHasProduct()"
                    :rules="[requiredProductExist]"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="productSelected.pcategoria"
                    class="text-field-uppercase"
                    label="Nome"
                    :disabled="disabledFieldsHasProduct()"
                    dense
                    :rules="[requiredProductExist]"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    :items="units"
                    item-text="name"
                    item-value="id"
                    v-model="productSelected.ficha_tecnica.unit_id"
                    :disabled="disabledFieldsHasProduct()"
                    label="Unidade"
                    outlined
                    :rules="[requiredProductExist]"
                    dense
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    :value="productSelected.grade.tm.join(', ')"
                    class="text-field-uppercase"
                    label="Tamanhos"
                    readonly
                    :disabled="disabledFieldsHasProduct()"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    :items="grids"
                    :item-text="
                      (item) =>
                        `${item.id} - ${item.sizes
                          .map((size) => size.size)
                          .join(' ')}`
                    "
                    item-value="id"
                    label="Grade"
                    outlined
                    :disabled="disabledFieldsHasProduct()"
                    :rules="[requiredProductExist]"
                    dense
                    v-model="productSelected.grid"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="productTypes"
                    item-text="name"
                    item-value="id"
                    v-model="productSelected.ficha_tecnica.product_type_id"
                    :disabled="disabledFieldsHasProduct()"
                    label="Tipo Produto"
                    @change="changeProductType()"
                    outlined
                    :rules="[requiredProductExist]"
                    dense
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    v-model="productSelected.ficha_tecnica.category_id"
                    :disabled="disabledFieldsHasProduct()"
                    label="Categoria"
                    @change="changeCategory()"
                    dense
                    outlined
                    :rules="[requiredProductExist]"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="filterByCategory(subcategories)"
                    item-text="name"
                    item-value="id"
                    v-model="productSelected.ficha_tecnica.subcategory_id"
                    :disabled="disabledFieldsHasProduct()"
                    label="Subcategoria"
                    dense
                    outlined
                    :rules="[requiredProductExist]"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    class="text-field-uppercase"
                    label="Preço Rede"
                    dense
                    outlined
                    v-model="productSelected.ficha_tecnica.price_cif"
                    :disabled="disabledFieldsHasProduct()"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    class="text-field-uppercase"
                    label="Preço Multimarcas"
                    v-model="productSelected.ficha_tecnica.price_mult"
                    :disabled="disabledFieldsHasProduct()"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="collections"
                    item-text="name"
                    item-value="id"
                    v-model="productSelected.collection_id"
                    class="text-field-uppercase"
                    label="Coleção"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="productSelected.ncm"
                    class="text-field-uppercase"
                    label="NCM"
                    dense
                    readonly
                    :disabled="disabledFieldsHasProduct()"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="productSelected.cest"
                    class="text-field-uppercase"
                    label="CEST"
                    dense
                    readonly
                    :disabled="disabledFieldsHasProduct()"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="productSelected.cst_origem"
                    class="text-field-uppercase"
                    label="CST Origem"
                    dense
                    readonly
                    :disabled="disabledFieldsHasProduct()"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="productSelected.cst_tribut"
                    class="text-field-uppercase"
                    label="CST Tribut."
                    dense
                    readonly
                    :disabled="disabledFieldsHasProduct()"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card elevation="2" class="mt-5" style="min-height: 170px">
            <v-card-title class="text-h6">Ficha Técnica</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <!-- <label class="text-h6"></label> -->
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-for="item in extraFields"
                  :key="item.id"
                  cols="12"
                  xs="12"
                  md="2"
                >
                  <v-select
                    v-if="item.type == 'selection'"
                    :items="item.values"
                    :label="item.name"
                    item-text="text"
                    item-value="value"
                    :disabled="disabledFieldsHasProduct()"
                    v-model="
                      productSelected.ficha_tecnica.extra_fields[item.id]
                    "
                    dense
                    outlined
                  ></v-select>
                  <v-text-field
                    v-if="item.type == 'text'"
                    class="text-field-uppercase"
                    :label="item.name"
                    dense
                    outlined
                    :disabled="disabledFieldsHasProduct()"
                    v-model="
                      productSelected.ficha_tecnica.extra_fields[item.id]
                    "
                  ></v-text-field>
                  <v-select
                    v-if="item.type == 'table' && item.values.table == 'soles'"
                    :items="soles"
                    :label="item.name"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    :disabled="disabledFieldsHasProduct()"
                    v-model="
                      productSelected.ficha_tecnica.extra_fields[item.id]
                    "
                  ></v-select>
                  <v-text-field
                    v-if="item.type == 'table' && item.values.table == 'grids'"
                    class="text-field-uppercase"
                    :label="item.name"
                    readonly
                    :value="numOfGrid"
                    dense
                    outlined
                    :disabled="disabledFieldsHasProduct()"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card elevation="2" class="mt-5" style="min-height: 150px">
            <v-card-title class="text-h6">Material / Cor</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <!-- <label class="text-h6"></label> -->
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table dense fixed-header height="300px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Material</th>
                          <th class="text-left">Cor</th>
                          <th class="text-left" width="380">Foto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="
                            filterMaterials(productSelected.attributes)
                              .length == 0
                          "
                        >
                          <td class="text-center" colspan="3">
                            <h2 class="text--gray pt-5 pb-5">
                              É necessário cadastrar os máterias e cores desse
                              produto para poder importar o XML
                            </h2>
                          </td>
                        </tr>
                        <tr
                          v-for="material in filterMaterials(
                            productSelected.attributes
                          )"
                          :key="`${productSelected.pcod}-${material.material_code}-${material.cor_code}`"
                        >
                          <td>
                            {{ material.material_code }} -
                            {{ material.material.name }}
                          </td>
                          <td>
                            {{ material.cor_code }} -
                            {{ material.cor.name }}
                          </td>
                          <td>
                            <v-row>
                              <v-col>
                                <v-img
                                  contain
                                  max-width="133"
                                  :aspect-ratio="16 / 9"
                                  :src="material.photo_url"
                                  class="image-product"
                                  @click="
                                    () =>
                                      showImageFullScreen(material.photo_url)
                                  "
                                ></v-img>
                              </v-col>
                              <v-col class="align-self-center">
                                <!-- <v-btn
                                  color="green darken-3"
                                  dark
                                  class="mt-0"
                                  small
                                  outlined
                                  @click="showImageGalery(material)"
                                >
                                  <v-icon>mdi-image</v-icon>
                                  Selecionar Foto
                                </v-btn> -->
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mt-3">
            <v-card-actions>
              <span class="font-weight-normal text-subtitle">
                Produto <b>{{ indexProduct + 1 }}</b> de
                <b>{{ produtos.length }}</b>
              </span>
              <v-btn
                color="blue darken-3"
                text
                outlined
                v-if="!showSalvar"
                @click="jumpToNextProduct()"
                class="ma-2 float-right"
                dark
              >
                Pular Produto
                <v-icon right> mdi-skip-next </v-icon>
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn
                color="grey darken-3"
                @click="goToPrev()"
                class="ma-2 float-right"
                v-if="indexProduct > 0"
                :loading="loadingProductPrev"
                text
              >
                <v-icon left> mdi-chevron-left </v-icon>
                Produto Anterior
              </v-btn>
              <v-btn
                color="green darken-3"
                @click="saveProducts()"
                v-if="showSalvar"
                dark
                class="ma-2 float-right"
              >
                <v-icon left> mdi-check </v-icon>
                Finalizar
              </v-btn>
              <v-btn
                color="blue ligthen-3"
                v-if="!showSalvar"
                @click="goToNext()"
                :loading="loadingProduct"
                class="ma-2 float-right"
                dark
              >
                Próximo Produto
                <v-icon right> mdi-chevron-right </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
        <v-container fliud v-if="page === 'finish'">
          <v-row>
            <v-col>
              <h1 class="text-center">Importação concluída com sucesso.</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center mt-5 mb-10">
              <v-btn color="success" @click="handleGoToHome()"
                >Voltar para tela de inicio</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      v-model="dialogImageGalery"
      persistent
      scrollable
      max-width="1400px"
    >
      <v-card>
        <v-card-title class="green text-h5 white--text lighten-2"
          >Galeria de Fotos</v-card-title
        >
        <v-divider></v-divider>
        <progress-bar
          :loading="loadingPhotos"
          :inderterminate="loadingPhotos"
        />
        <v-card-text class="mt-2 subtitle-1">
          <span>
            Produto Selecionado: <b>{{ productSelected.pcod }}</b>
          </span>
          <span>
            Material:
            <b>
              {{ attributeSelected.material_code }} -
              {{ attributeSelected.material.name }}
            </b>
          </span>
          <span>
            Cor:
            <b>
              {{ attributeSelected.cor_code }} -
              {{ attributeSelected.cor.name }}
            </b>
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-2">
          <v-row class="mt-2">
            <v-col cols="12" xs="12" md="3">
              <v-select
                v-model="collection"
                :items="collections"
                item-text="name"
                item-value="id"
                label="Coleção"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <!-- <v-col>
              <v-select
                v-model="provider"
                :items="providers"
                label="Fornecedor"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col> -->
            <v-col cols="12" xs="12" md="3">
              <v-btn
                color="blue darken-3"
                dark
                class="mt-0"
                @click="getPhotosProducts()"
              >
                <v-icon left>mdi-image</v-icon> Carregar Fotos
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="text-h6 black--text">Fotos</label>
              <v-divider></v-divider>
              <label v-if="showImages" class="body-1 black--text float-right"
                >{{ photos.length }} Fotos</label
              >
            </v-col>
          </v-row>
          <v-row v-if="showImages">
            <v-radio-group v-model="radioPhoto" row>
              <v-col
                v-for="photo in photos"
                :key="photo.id"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card>
                  <v-img
                    :src="photo.full_url"
                    :lazy-src="photo.full_url"
                    aspect-ratio="1.7777"
                    class="grey lighten-2 image-product"
                    @click="handleClickPhoto(photo.id)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-card-text class="caption font-weight-bold">
                    <v-radio
                      :key="photo.id"
                      :label="photo.name"
                      :value="photo.id"
                    ></v-radio>
                    <!-- {{ photo.name }} -->
                  </v-card-text>
                </v-card>
              </v-col>
            </v-radio-group>
            <v-col v-if="photos.length === 0">
              <p class="title">Nenhuma foto encontrada nessa Coleção</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogImageGalery = false">
            Fechar
          </v-btn>
          <v-btn color="green darken-1" dark @click="handleSelectPhoto()">
            Selecionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSaveProducts" max-width="500px">
      <v-card>
        <v-toolbar color="green lighten-1" dark class="text-h5">
          Atenção
        </v-toolbar>
        <v-card-title class="text-h6">
          Tem certeza que deseja salvar a importação dos produtos?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogSaveProducts = false">
            Fechar
          </v-btn>
          <v-btn color="green darken-1" dark @click="confirmSave()">
            <v-icon dark>mdi-check</v-icon>
            Salvar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogImageFullScreen" scrollable max-width="1300">
      <v-card>
        <!-- <v-toolbar color="green lighten-1" dark class="text-h5">
          Atenção
        </v-toolbar> -->
        <v-card-text>
          <v-spacer></v-spacer>
          <v-img
            contain
            max-width="1200"
            :aspect-ratio="16 / 9"
            :src="imageFullScreen"
          ></v-img>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogImageFullScreen = false"
          >
            Fechar
          </v-btn>
          <!-- <v-btn color="green darken-1" dark @click="confirmSave()">
            <v-icon dark>mdi-check</v-icon>
            Salvar
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { URL, URL_IMAGE } from "@/api/config";

import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as GridAPI from "@/api/requests/GridRequest";
import * as SubcategoryAPI from "@/api/requests/SubcategoryRequest";
import * as UnitAPI from "@/api/requests/UnitRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";
import ProgressBar from "@/components/ProgressBar";
import imageNotFound from "@/assets/produto-sem-imagem.jpg";

export default {
  components: {
    Alert,
    ProgressBar,
  },
  data: () => ({
    provider_id: 18,
    dessertHeaders: [
      {
        text: "Produto",
        align: "start",
        sortable: false,
        value: "nome",
      },
      { text: "Referencia", value: "referencia" },
      { text: "Unidade", value: "unidade" },
      { text: "Tamanhos", value: "tamanhos" },
      { text: "Atributos", value: "atributos" },
      { text: "", value: "data-table-expand" },
    ],
    page: "home",
    expanded: [],
    produtos: [],
    empresa: {
      cnpj: "",
      nome: "",
    },
    typeProduct: "",
    loading: false,
    loadingPhotos: false,
    error: "",
    company: "",
    companies: [],
    valid: true,
    lazy: false,
    dialogExample: false,
    dialogSaveProducts: false,
    successSave: false,
    statusAlert: false,
    messageAlert: "",
    typeAlert: "error",
    soles: [],
    file: "",
    loadingCompanies: false,
    errorXmlMessage: "",
    xml: {
      gerador: {
        empresa_existe: false,
      },
      produtos: {
        produto: [],
      },
    },
    dialogImageGalery: false,
    providers: [],
    provider: "",
    collection: "",
    collections: [],
    showImages: false,
    grids: [],
    units: [],
    productTypes: [],
    productSelected: {},
    extraFields: [],
    category_id: "",
    subcategories: [],
    categories: [],
    showSalvar: false,
    loadingProduct: false,
    loadingProductPrev: false,
    imageNotFound: imageNotFound,
    dialogImageFullScreen: false,
    imageFullScreen: "",
    photos: [],
    radioPhoto: "",
    lastCollection: "",
    attributeSelected: {
      material: {},
      cor: {},
    },
    materials: [],
    rules: {
      required: (value) => {
        if (this.notRequiredIfProductExist()) {
          return true;
        } else {
          return !!value || "Campo Obrigatorio";
        }
      },
    },
    indexProduct: 0,
    jumpProduct: false,
  }),
  computed: {
    numOfGrid: function () {
      if (typeof this.productSelected.grid !== "undefined") {
        let gridSelected = this.grids.find(
          (item) => item.id === this.productSelected.grid
        );
        return `${gridSelected.sizes[0].size} até ${
          gridSelected.sizes[gridSelected.sizes.length - 1].size
        }`;
      }
      return "";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
      this.getGrids();
      this.getUnits();
      this.getSoles();
      this.getCategories();
      this.getSubcategories();
      this.getProductTypes();
      this.getCollections();
    },
    validate() {
      // console.log(this.file);
      let form = new FormData();
      if (this.file === "" || this.file == undefined) {
        this.showAlert("error", "Selecione um arquivo para poder continuar");
        return false;
      }
      form.append("file", this.file);
      this.xmlValidate(form);
      // if (this.$refs.form.validate()) {}
    },
    goToBackList() {
      this.$router.push({ name: "Product" });
    },
    onFilePicked(e) {
      this.file = e;
      this.errorXmlMessage = "";
    },
    async xmlValidate(data) {
      this.loading = false;
      try {
        let res = await fetch(`${URL}product-import/validate`, {
          method: "POST",
          body: data,
        });
        if (res) {
          let response = await res.json();
          this.xml = response;
          // this.empresa = { nome: response.empresa, cnpj: response.cnpj };
          // this.produtos = response.produtos;
          // this.dialogExample = true;
          console.log(response);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    mostrarItem(item) {
      console.log(item);
    },
    async getCompanies() {
      this.loadingCompany = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
      } finally {
        this.loadingCompany = false;
      }
    },
    getMaterials(product) {
      // let product = this.productSelected;
      let data = [];
      if (Array.isArray(product.materiais.material)) {
        product.materiais.material.map((item) => {
          if (Array.isArray(item.cores)) {
            let tempData = item.cores.map((cor) => {
              return {
                material: item.material_existe ? item.material_db : false,
                material_code: item.fmatcod,
                cor: cor.cor.cor_existe ? cor.cor.cor_db : false,
                cor_code: cor.cor.fcrcod,
                photo_url: imageNotFound,
                eans: cor.cor.eans,
                photo: {},
              };
            });
            data = [...data, ...tempData];
          } else {
            let tempData = item.cores.cor.map((corIn) => {
              return {
                material: item.material_existe ? item.material_db : false,
                material_code: item.fmatcod,
                cor: corIn.cor_existe ? corIn.cor_db : false,
                cor_code: corIn.fcrcod,
                photo_url: imageNotFound,
                photo: {},
              };
            });
            data = [...data, ...tempData];
          }
        });
      }
      return data;
    },
    getColors(product) {
      if (Array.isArray(product.materiais.material)) {
        return product.materiais.material.reduce((acc, item) => {
          if (Array.isArray(item.cores)) {
            return acc + item.cores.length;
          } else {
            return acc + 1;
          }
        }, 0);
      } else {
        if (Array.isArray(product.materiais.material.cores)) {
          return product.materiais.material.cores.length;
        } else {
          return 1;
        }
      }
    },
    async getGrids() {
      this.loading = true;
      try {
        let data = await GridAPI.getAll();
        this.grids = data.sort((a, b) => (a.id > b.id ? 1 : -1));
      } catch (error) {
        this.grids = {};
      } finally {
        this.loading = false;
      }
    },
    async getUnits() {
      this.loading = true;
      try {
        let data = await UnitAPI.getAll();
        this.units = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.units = {};
      } finally {
        this.loading = false;
      }
    },
    async getSubcategories() {
      this.loading = true;
      try {
        let data = await SubcategoryAPI.getAll();
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.subcategories = {};
      } finally {
        this.loading = false;
      }
    },
    async getCategories() {
      this.loading = true;
      try {
        let data = await CategoryAPI.getAll();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // if (this.productSele.id !== "") {
        //   this.changeCategory();
        // }
      } catch (error) {
        this.categories = {};
      } finally {
        this.loading = false;
      }
    },
    async getSoles() {
      this.loading = true;
      try {
        let response = await fetch(`${URL}sole`);
        let data = await response.json();
        this.soles = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.soles = {};
      } finally {
        this.loading = false;
      }
    },
    async getProductTypes() {
      this.loading = true;
      try {
        let response = await fetch(`${URL}product-types`);
        let data = await response.json();
        this.productTypes = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.productTypes = {};
      } finally {
        this.loading = false;
      }
    },
    async getCollections() {
      this.loading = true;
      try {
        this.collections = await CollectionAPI.getAll();
        this.lastCollection = this.collections[this.collections.length - 1].id;
      } catch (error) {
        this.collections = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    changeCategory() {
      // let old_category_id = this.category_id;
      // let categorySelected = this.categories.find(
      //   (item) => item.id === this.productSelected.ficha_tecnica.category_id
      // );
      this.category_id = this.productSelected.ficha_tecnica.category_id;
      // if (old_category_id !== this.category_id) {
      //   // this.subcategories = [];
      //   // this.getSubcategories();
      // }
    },
    showImageGalery(material) {
      this.attributeSelected = material;

      if (this.collection == "") {
        let collectionId = this.collections[this.collections.length - 1].id;
        this.collection = collectionId;
        this.getPhotosProducts();
      } else {
        if (this.photos.length > 0) {
          this.showImages = true;
        } else {
          this.showImages = false;
        }
        if (Object.keys(material.photo).length > 0) {
          this.radioPhoto = material.photo.id;
        } else {
          this.radioPhoto = "";
        }
      }

      this.dialogImageGalery = true;
    },
    async getPhotosProducts() {
      console.log("getPhotosProducts");
      // console.log(this.provider_id);
      // console.log(this.collection);
      // this.loadingPhotos = true;
      // try {
      //   let response = await fetch(
      //     `${URL}photo-galery?company_id=${this.provider_id}&collection_id=${this.collection}`
      //   );
      //   let res = await response.json();
      //   let data = [];
      //   res
      //     .map((galery) => galery.photos)
      //     .map((element) => {
      //       element.map((item) => {
      //         data = data.concat(item);
      //       });
      //     });

      //   data = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      //   this.photos = data.map((photo) => ({
      //     ...photo,
      //     full_url: this.getUrlImage(photo.url),
      //   }));
      //   console.log(this.photos);
      // } catch (error) {
      //   this.photos = [];
      //   console.log(error);
      // } finally {
      //   this.showImages = true;
      //   this.loadingPhotos = false;
      // }
    },
    getUrlImage(image) {
      return `${URL_IMAGE}${image}`;
    },
    nextPage(page) {
      if (this.xml.produtos.produto.length === 0) {
        this.showAlert(
          "error",
          "Selecione um arquvio para poder avançar na importação"
        );
        return false;
      }
      this.produtos = this.xml.produtos.produto;
      this.produtos = this.produtos.map((item) => ({
        ...item,
        collection_id: this.lastCollection,
        cest:
          Array.isArray(item.cest) && item.cest.length == 0 ? "" : item.cest,
        ficha_tecnica: {
          unit_id:
            this.units.find((unit) => unit.code === item.punid) !== undefined
              ? this.units.find((unit) => unit.code === item.punid).id
              : "",
          extra_fields: [],
        },
        attributes: this.getMaterials(item),
      }));
      console.log(this.produtos);
      this.setProductSelected(this.produtos[0]);
      this.page = page;
      console.log(this.productSelected);

      this.hideAlert();
      if (this.indexProduct === this.produtos.length - 1) {
        this.showSalvar = true;
        return true;
      }
    },
    changeProductType() {
      const type = this.productTypes.find(
        (item) => item.id === this.productSelected.ficha_tecnica.product_type_id
      );
      console.log(type);
      if (type !== undefined) {
        const fields = type.fields;
        this.extraFields = fields;
      }
    },
    filterMaterials(materials) {
      if (typeof materials === "undefined") return true;
      return materials.filter(
        (item) => item.material !== false && item.cor !== false
      );
    },
    goToPrev() {
      if (this.indexProduct === 0) return;

      this.loadingProductPrev = true;
      setTimeout(() => {
        this.loadingProductPrev = false;
        this.$vuetify.goTo(0, {
          duration: 200,
          offset: 0,
          easing: "easeInOutCubic",
        });
      }, 500);

      this.indexProduct = this.indexProduct - 1;
      this.setProductSelected(this.produtos[this.indexProduct]);
      // this.productSelected = this.produtos[this.indexProduct];
      // this.getMaterials(this.productSelected);
      this.showSalvar = false;
    },
    goToNext() {
      this.hideAlert();
      if (this.indexProduct === this.produtos.length - 1) {
        this.showSalvar = true;
        return true;
      } else if (
        this.filterMaterials(this.productSelected.attributes).length === 0
      ) {
        console.log("sem material e cor");
        this.goToNextProduct();
        return true;
      } else {
        this.saveProduct(this.productSelected);
      }

      // console.log(this.productSelected);

      // this.loadingProduct = true;
      // // setTimeout(() => {
      // this.loadingProduct = false;
      // this.$vuetify.goTo(0, {
      //   duration: 200,
      //   offset: 0,
      //   easing: "easeInOutCubic",
      // });
      // if (this.validateRequiredFields()) {
      //   this.$refs.form.resetValidation();
      //   this.showSalvar = false;
      //   this.indexProduct = this.indexProduct + 1;
      //   this.setProductSelected(this.produtos[this.indexProduct]);
      //   // this.productSelected = this.produtos[this.indexProduct];
      //   // this.getMaterials(this.productSelected);
      //   if (this.indexProduct === this.produtos.length - 1) {
      //     this.showSalvar = true;
      //     return;
      //   }
      // }
      // }, 600);
    },
    goToNextProduct() {
      this.$vuetify.goTo(0, {
        duration: 200,
        offset: 0,
        easing: "easeInOutCubic",
      });
      this.showSalvar = false;
      this.indexProduct = this.indexProduct + 1;
      this.setProductSelected(this.produtos[this.indexProduct]);
      if (this.indexProduct === this.produtos.length - 1) {
        this.showSalvar = true;
      }
    },
    jumpToNextProduct() {
      this.jumpProduct = true;
      this.hideAlert();
      this.$vuetify.goTo(0, {
        duration: 200,
        offset: 0,
        easing: "easeInOutCubic",
      });
      this.showAlert("warning", "Produto pulado, não será gravado no banco");
      this.showSalvar = false;
      this.indexProduct = this.indexProduct + 1;
      this.setProductSelected(this.produtos[this.indexProduct]);
      this.jumpProduct = false;
      if (this.indexProduct === this.produtos.length - 1) {
        this.showSalvar = true;
      }
    },
    async saveProduct(product) {
      this.loadingProduct = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}product-import/save`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            product: product,
            provider: this.xml.gerador.empresa,
          }),
        });
        res = await res.json();

        let messageSave = `Produto salvo com sucesso - Referencia ${res.product.reference}`;
        let colorMessage = "success";
        if (product.produto_existe) {
          messageSave = `Produto atualizado com sucesso - Referencia ${res.product.reference}`;
          colorMessage = "info";
        }

        this.showAlert(colorMessage, messageSave);

        this.produtos[this.indexProduct].produto_existe = true;
        this.produtos[this.indexProduct].produto_db = res.product;

        if (this.indexProduct === this.produtos.length - 1) {
          this.showPageFinish();
        } else {
          this.goToNextProduct();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingProduct = false;
      }
    },
    resetAll() {
      this.xml = {
        gerador: {
          empresa_existe: false,
        },
        produtos: {
          produto: [],
        },
      };
      this.produtos = 0;
      this.indexProduct = 1;
      this.provider = "";
      this.file = "";
      this.productSelected = {};
      this.page = "home";
      this.company = "";
    },
    validateRequiredFields() {
      return this.$refs.form.validate();
    },
    filterByCategory(subcategories) {
      if (this.category_id === "") return [];
      return subcategories.filter(
        (sub) => sub.category_id === this.category_id
      );
    },
    async saveProducts() {
      await this.saveProduct(this.productSelected);
      this.showPageFinish();
      // if (this.indexProduct === this.produtos.length - 1) {
      //   this.showAlert(
      //     "success",
      //     "Produto salvo com sucesso - Referencia " + this.productSelected.pcod
      //   );
      //   this.resetAll();
      // } else {
      // }
      // this.dialogSaveProducts = true;
    },
    showPageFinish() {
      this.page = "finish";
    },
    async confirmSave() {
      this.dialogSaveProducts = false;
      console.log(this.produtos);
      console.log(this.xml.gerador);
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}product-import/save`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            gerador: this.xml.gerador,
            produtos: this.produtos,
          }),
        });
        if (res) {
          let response = await res.json();
          console.log(response);
          this.$router.push({ name: "ProductListImport" });
          // ProductListImport
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    showAlert(type, message) {
      this.typeAlert = type;
      this.messageAlert = message;
      this.statusAlert = true;
    },
    hideAlert() {
      this.statusAlert = false;
    },
    handleClickPhoto(id) {
      this.radioPhoto = id;
    },
    handleSelectPhoto() {
      let photoSelected = this.photos.find(
        (item) => item.id === this.radioPhoto
      );
      let index = this.productSelected.attributes.findIndex(
        (item) =>
          item.material.id === this.attributeSelected.material.id &&
          item.cor.id === this.attributeSelected.cor.id
      );
      let copyAttr = this.productSelected.attributes[index];
      copyAttr.photo_url = photoSelected.full_url;
      copyAttr.photo = photoSelected;
      this.productSelected.attributes.splice(index, 1, copyAttr);
      this.dialogImageGalery = false;
    },
    showImageFullScreen(image) {
      this.imageFullScreen = image;
      this.dialogImageFullScreen = true;
    },
    disabledFieldsHasProduct() {
      if (this.filterMaterials(this.productSelected.attributes).length === 0) {
        return true;
      }
      return this.productSelected.produto_existe;
    },
    notRequiredIfProductExist() {
      if (this.filterMaterials(this.productSelected.attributes).length === 0) {
        return true;
      }
      return this.productSelected.produto_existe;
    },
    setProductSelected(product) {
      this.productSelected = product;
      if (this.productSelected.produto_existe) {
        const { produto_db } = { ...this.productSelected };
        this.productSelected.grid = produto_db.grid_id;
        // eslint-disable-next-line prettier/prettier
        this.productSelected.ficha_tecnica.category_id = produto_db.category_id;
        this.category_id = produto_db.category_id;
        // eslint-disable-next-line prettier/prettier
        this.productSelected.ficha_tecnica.subcategory_id =
          produto_db.subcategory_id;
        // eslint-disable-next-line prettier/prettier
        this.productSelected.ficha_tecnica.product_type_id =
          produto_db.product_type_id;
        this.changeProductType();
        // eslint-disable-next-line prettier/prettier
        this.productSelected.ficha_tecnica.price_cif = produto_db.price_cif;
        // eslint-disable-next-line prettier/prettier
        this.productSelected.ficha_tecnica.price_mult = produto_db.price_mult;
        // eslint-disable-next-line prettier/prettier
        this.productSelected.ficha_tecnica.unit_id = produto_db.unit_id;

        this.productSelected.ncm = produto_db.ncm;
        this.productSelected.cst_origem = produto_db.cst_orig;
        this.productSelected.cst_tribut = produto_db.cst_trib;
        this.productSelected.grid = produto_db.grid_id;
      }
    },
    requiredProductExist(value) {
      if (this.jumpProduct) {
        return false;
      }
      if (this.notRequiredIfProductExist()) {
        return true;
      } else {
        return !!value || "Campo Obrigatorio";
      }
    },
    handleGoToHome() {
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>

<style scoped>
.border-table {
  border: 1px solid #dddddd !important;
}
table th + th {
  border-left: 1px solid #dddddd;
}
table td + td {
  border-left: 1px solid #dddddd;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
  margin-bottom: 2px;
}
.align-self-center {
  align-self: center;
}
.image-product {
  cursor: pointer;
}
</style>
